import CountyStation from "modules/common/components/Alarms/Form/components/CountiesStations/CountyStation";
import { ReactComponent as AddIcon } from "assets/icons/add.svg";
import Select from "react-select";
import { FC, useContext, useMemo } from "react";
import { County } from "services";
import { SelectedCountyStation } from "../../../types/AlarmModels";
import { Station } from "../../../types/AlarmsForm";
import { AccessibilityContext } from "views/AccessibilityContext";

// TODO: use Dropdown instead of Select
interface Props {
    selectedCounty?: County;
    counties: County[];
    selectedStation?: Station;
    stations: Station[];
    selectedCountyStations: SelectedCountyStation[];
    setSelectedCounty: React.Dispatch<React.SetStateAction<County | null>>;
    setSelectedStation: React.Dispatch<React.SetStateAction<Station | null>>;
    addCountyStation: () => void;
    changeSelectedCounty: (
        currentCounty?: County,
        newCounty?: County,
        currentStation?: Station
    ) => void;
    changeSelectedStation: (currentStation?: Station, newStation?: Station) => void;
    removeCountyStation: (county?: County, station?: Station) => void;
}

const CountiesStations: FC<Props> = ({
    counties,
    stations,
    selectedCountyStations,
    selectedCounty,
    selectedStation,
    setSelectedCounty,
    setSelectedStation,
    addCountyStation,
    removeCountyStation,
    changeSelectedCounty,
    changeSelectedStation,
}) => {
    const filteredStations = useMemo(() => {
        if (!selectedCounty) return [];
        return stations.filter(
            s =>
                s.zupanija?.id === selectedCounty?.id &&
                !selectedCountyStations.some(
                    cs => cs.stationId === s.id && cs.countyId === selectedCounty?.id
                )
        );
    }, [stations, selectedCounty, selectedCountyStations]);
    const { lowVision } = useContext(AccessibilityContext);
    return (
        <>
            <div className="alarms-form-country-station-inputs alarms-form-container">
                <div>
                    <label>Županija</label>
                    <Select
                        value={selectedCounty}
                        options={counties}
                        getOptionLabel={c => c.name}
                        getOptionValue={c => String(c.id)}
                        onChange={c => {
                            setSelectedCounty(c);
                            setSelectedStation(null);
                        }}
                        className={lowVision ? "low-vision" : ""}
                        classNamePrefix="react-select"
                    />
                </div>
                <div>
                    <label>Stanica</label>
                    <Select
                        value={selectedStation ?? null}
                        options={filteredStations}
                        getOptionLabel={s => s.name}
                        getOptionValue={s => String(s.id)}
                        onChange={s => setSelectedStation(s)}
                        className={lowVision ? "low-vision" : ""}
                        classNamePrefix="react-select"
                    />
                </div>
                <AddIcon className="alarms-form-add-icon" onClick={addCountyStation} />
            </div>

            {selectedCountyStations.map(i => (
                <CountyStation
                    key={i.stationId + i.countyId}
                    selectedCountyStation={i}
                    counties={counties}
                    stations={stations}
                    selectedCountyStations={selectedCountyStations}
                    onCountyChange={changeSelectedCounty}
                    onStationChange={changeSelectedStation}
                    removeCountyStation={removeCountyStation}
                />
            ))}
        </>
    );
};

export default CountiesStations;
